// document.addEventListener('variant:added', function(event) {
//   const isProductAccessory = document.querySelector('.product-accessory');
//   if(!!isProductAccessory) return;
//   const modal = document.getElementById("ringModal");
//    modal.style.display = "flex";
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const modal = document.getElementById("ringModal");
//   const isProductAccessory = document.querySelector('.product-accessory');
//   if(!!isProductAccessory) return;

//   const hasSeenModal = localStorage.getItem("ringModalShown");
    
//   if (!hasSeenModal) {
//     setTimeout(function () {
//       modal.style.display = "flex";

//       localStorage.setItem("ringModalShown", "true");
//     }, 15000);
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("ringModal");
  const isProductAccessory = document.querySelector('.product-accessory');
  if(!!isProductAccessory) return;

  const lastShown = localStorage.getItem("ringModalShownAt");
  const now = new Date().getTime();
  const daysSinceLastShown = lastShown ? (now - parseInt(lastShown, 10)) / (1000 * 60 * 60 * 24) : Infinity;

  if (daysSinceLastShown > 7) {
    setTimeout(function () {
      modal.style.display = "flex";
      localStorage.setItem("ringModalShownAt", now.toString());
    },15000);
  }
});


 document.addEventListener("DOMContentLoaded", function () {
  const modal = document.getElementById("ringModal");
  const closeButtons = modal.querySelectorAll(".ring-modal-close, .ring-modal-close-icon");

  closeButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      modal.style.display = "none";
    });
  });
});